module.exports = __webpack_public_path__ + "static/media/dash.72050ffb.svg";